import {
  CalendarDays,
  LayoutDashboard,
  Settings,
  UserRound,
  ClipboardCheck,
  type LucideIcon,
} from "lucide-react";

/**
 * Per-portal navigation config. New internal modules (Analytics, Audit Logs,
 * Hospital / Patient Management, Reports, Settings) are added by extending one
 * of these arrays — the sidebar and shells never change.
 */
export interface NavItem {
  title: string;
  url: string;
  icon: LucideIcon;
}

export const DOCTOR_NAV: NavItem[] = [
  { title: "Dashboard", url: "/dashboard", icon: LayoutDashboard },
  { title: "Bookings", url: "/bookings", icon: CalendarDays },
  { title: "Profile", url: "/profile", icon: UserRound },
  { title: "Settings", url: "/settings", icon: Settings },
];

export const ADMIN_NAV: NavItem[] = [
  { title: "Dashboard", url: "/admin", icon: LayoutDashboard },
  { title: "Pending Doctors", url: "/admin/doctors", icon: ClipboardCheck },
];
